import React from 'react';

import {Card, CardContent, Stack, Typography, Avatar, Box} from 'views/components';
import {EditCalendar, Cached, FavoriteBorder, Checklist} from 'views/icons';
import {Translate, translate, MarkdownViewer} from 'views/module';

const CareQuiltAdvantageCard = () => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Stack>
            <Typography component='div' variant='h6'>
              <Translate expression={'dashboard.sections.info.careQuiltAdvantageTitle'}/>
            </Typography>
            <Typography component='div' variant='body2' color='text.secondary'>
              <MarkdownViewer value={translate('dashboard.sections.info.careQuiltAdvantage')}/>
            </Typography>
          </Stack>

          <Box
            display='grid'
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
            }}
            height='content-fit'
            gap={2}
          >
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <EditCalendar sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.seamlessLogisticsTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.seamlessLogistics')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <Cached sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.carePlanEvolutionTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.carePlanEvolution')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <FavoriteBorder sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.mediationAdvocacyTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.mediationAdvocacy')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
            <Card sx={{bgcolor: 'background.default', pb: 3}}>
              <Stack spacing={2}>
                <Box>
                  <Avatar sx={{bgcolor: 'Background', mt: 2}}>
                    <Checklist sx={{color: 'InfoText'}}/>
                  </Avatar>
                </Box>
                <Stack>
                  <Typography component='div' variant='subtitle'>
                    <Translate expression={'dashboard.sections.info.vettingExcellenceTitle'}/>
                  </Typography>
                  <Typography component='div' variant='body2' color='text.secondary'>
                    <MarkdownViewer value={translate('dashboard.sections.info.vettingExcellence')}/>
                  </Typography>
                </Stack>
              </Stack>
            </Card>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CareQuiltAdvantageCard;
